import React from 'react';
import Icon from '../../../components/AppIcon';
import { useNavigate } from 'react-router-dom';
import { HELP_ARTICLES } from '../../../data/helpArticles';

const PopularArticles = () => {
  const navigate = useNavigate();

  // Top articles by view count
  const articles = [...HELP_ARTICLES]
    .sort((a, b) => b.views - a.views)
    .slice(0, 6);

  const getDifficultyColor = (difficulty) => {
    switch (difficulty) {
      case 'Beginner':     return 'bg-green-500/10 text-green-500';
      case 'Intermediate': return 'bg-yellow-500/10 text-yellow-500';
      case 'Advanced':     return 'bg-red-500/10 text-red-500';
      default:             return 'bg-muted text-muted-foreground';
    }
  };

  const handleArticleClick = (article) => {
    navigate(`/knowledge-base-articles?article=${article?.id}`);
  };

  return (
    <div className="mb-12">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-2xl font-heading font-semibold text-foreground mb-1">
            Popular Articles
          </h2>
          <p className="text-sm text-muted-foreground">
            Most viewed articles this month
          </p>
        </div>
        <button
          onClick={() => navigate('/knowledge-base-articles')}
          className="text-primary hover:text-primary/80 font-medium text-sm flex items-center gap-2 transition-smooth"
        >
          View All
          <Icon name="ArrowRight" size={16} />
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {articles?.map((article) => (
          <button
            key={article?.id}
            onClick={() => handleArticleClick(article)}
            className="group bg-card border border-border rounded-lg p-5 hover:shadow-elevation-md hover:border-primary/50 transition-smooth text-left"
          >
            <div className="flex items-start justify-between mb-3">
              <span className={`px-2.5 py-1 rounded-md text-xs font-medium ${getDifficultyColor(article?.difficulty)}`}>
                {article?.difficulty}
              </span>
              <div className="flex items-center gap-1 text-muted-foreground">
                <Icon name="Star" size={14} className="text-yellow-500 fill-yellow-500" />
                <span className="text-xs font-medium">{article?.rating}</span>
              </div>
            </div>

            <h3 className="text-base font-heading font-semibold text-foreground mb-2 group-hover:text-primary transition-smooth line-clamp-2">
              {article?.title}
            </h3>
            <p className="text-sm text-muted-foreground mb-4 line-clamp-2">
              {article?.description}
            </p>

            <div className="flex items-center justify-between text-xs text-muted-foreground">
              <div className="flex items-center gap-3">
                <div className="flex items-center gap-1">
                  <Icon name="Eye" size={12} />
                  <span>{article?.views?.toLocaleString()}</span>
                </div>
                <div className="flex items-center gap-1">
                  <Icon name="Clock" size={12} />
                  <span>{article?.readTime}</span>
                </div>
              </div>
              <span className="text-primary font-medium">{article?.category}</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default PopularArticles;
